import React, { useContext, useEffect, useState } from "react";
import { NavContext } from "../../state/NavContext";
import { Form, Input, Button, Divider, Typography, Modal } from "antd";
import { useHistory } from "react-router-dom";
import axios from "axios";

const { Title, Text } = Typography;

const Register = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("login");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  const onFinish = (values) => {
    setIsLoading(true);

    axios
      .post("https://backendexample.sanbersy.com/api/register", {
        name: values.name,
        email: values.email,
        password: values.password,
      })
      .then((res) => {
        setIsLoading(false);

        Modal.success({
          title: "Success",
          content: "Registration success, please login to continue",
          onOk: () => {
            history.push("login");
          },
        });
      })
      .catch((err) => {
        const errorResponse = JSON.parse(err.response.data);
        const errorEmail = errorResponse.email[0]
          ? errorResponse.email[0]
          : "Error Occured";

        setIsLoading(false);

        Modal.error({
          title: "Failed",
          content: `Registration failed, ${errorEmail}`,
        });
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="auth-form">
      <Title level={2} style={{ textAlign: "center", marginBottom: "40px" }}>
        Register
      </Title>
      <Form
        name="basic"
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: false }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="name"
          label="name"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input placeholder="Input your name" />
        </Form.Item>

        <Form.Item
          name="email"
          label="email"
          rules={[
            {
              type: "email",
              message: "The input is not valid E-mail!",
            },
            {
              required: true,
              message: "Please input your E-mail!",
            },
          ]}
        >
          <Input type="email" placeholder="Input your email" />
        </Form.Item>

        <Form.Item
          name="password"
          label="password"
          rules={[
            { required: true, message: "Please input your password!" },
            {
              min: 6,
              message: "password must be at least 6 characters",
            },
          ]}
        >
          <Input.Password placeholder="Input your password" />
        </Form.Item>

        <Form.Item
          name="confpassword"
          label="confirmation password"
          rules={[
            {
              required: true,
              message: "Please input your confirmation password!",
            },
            {
              min: 6,
              message: "password must be at least 6 characters",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The two passwords that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Input your password" />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 24 }}>
          <Button type="primary" htmlType="submit" block loading={isLoading}>
            Register
          </Button>
        </Form.Item>

        <Divider type="horizontal">
          <Text style={{ fontWeight: "normal" }} type="secondary">
            Already Have An Account?
          </Text>
        </Divider>

        <Button
          className="btn-success"
          type="primary"
          onClick={() => history.push("/login")}
          block
        >
          Login
        </Button>
      </Form>
    </div>
  );
};

export default Register;
